import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { ReactNode, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface RequiredConfirmationDialogProps {
  onConfirm: () => void
  title?: ReactNode
  children?: ReactNode
  label?: string
}

/**
 * A dialog that requires the user to confirm an action before proceeding.
 * This dialog cannot be closed without confirming.
 */
const RequiredConfirmationDialog = ({ onConfirm, title, children, label }: RequiredConfirmationDialogProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const handleConfirm = useCallback(() => {
    setOpen(false)
  }, [])
  const slotProps = useMemo(
    () => ({
      transition: {
        onExited: () => {
          onConfirm()
        },
      },
    }),
    [onConfirm],
  )

  return (
    <Dialog open={open} disableEscapeKeyDown slotProps={slotProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleConfirm}>
          {label || t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RequiredConfirmationDialog
